import { Dialog, IDialogProps } from '../components/Dialog';
import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';

export type UseDialogResponse = [
    open: () => void,
    close: () => void,
]

export const useDialog = (props: Omit<IDialogProps, 'open'|'ref'>): UseDialogResponse => {
    const dialogRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        const el = document.createElement('div');
        document.body.append(el);

        const root = ReactDOM.createRoot(el);
        root.render(<Dialog open={false} ref={dialogRef} {...props}>{props.children}</Dialog>);

        return () => {
            el.remove();
        };
    }, [ props ]);

    const open = useCallback(() => {
        try {
            dialogRef.current?.showModal();
        } catch (e) {
        }
    }, []);
    const close = useCallback(() => {
        dialogRef.current?.close();
    }, []);

    return [ open, close ];
};
